import React from "react";

const Footer = () => {
  return (
    <div className='mt-4 bg-dark-200 rounded-md text-white px-8 py-4'>
      <ul className='text-center'>
        <li>
          <a href='#home' className='hover:underline'>
            About
          </a>
        </li>
        <li>
          <a href='#education' className='hover:underline'>
            Education
          </a>
        </li>
        <li>
          <a href='#experience' className='hover:underline'>
            Experience
          </a>
        </li>
        <li>
          <a href='#skills' className='hover:underline'>
            Skills
          </a>
        </li>
        <li>
          <a href='#publications' className='hover:underline'>
            Publications
          </a>
        </li>
        <li>
          <a href='#projects' className='hover:underline'>
            Projects
          </a>
        </li>
        <li>
          <a href='#certs' className='hover:underline'>
            Certfications
          </a>
        </li>
      </ul>

      <p className='text-sm font-light text-center'>
        Copyright © 2023 Mohammad Rakibul Hasan Mahin. All Right Reserved
      </p>
    </div>
  );
};

export default Footer;
